<template>
  <el-drawer
    title="账单详情"
    append-to-body
    :modal-append-to-body="false"
    :visible.sync="drawer"
    destroy-on-close
    :wrapperClosable="false"
    :custom-class="sidebarIsOpen ? 'widthSpecial210' : 'widthSpecial54'"
  >
    <el-card style="padding: 0 12px">
      <el-table v-loading="loading" ref="multipleTable" row-key="id" :data="tableData" tooltip-effect="light" :header-cell-style="{ backgroundColor: '#ffffff', color: '#000' }">
        <el-table-column type="index" width="50" label="序号" align="center" />
        <el-table-column label="应收日期" align="center" width="100">
          <template slot-scope="scope">{{ cutTime(scope.row.billDate, ' ') }}</template>
        </el-table-column>
        <el-table-column label="费用时间" align="center" width="200">
          <template slot-scope="scope">
            <span v-if="scope.row.chargeBeginDate">{{ cutTime(scope.row.chargeBeginDate, ' ') }}</span>
            <span v-if="scope.row.chargeBeginDate && scope.row.chargeEndDate">至</span>
            <span v-if="scope.row.chargeEndDate">{{ cutTime(scope.row.chargeEndDate, ' ') }}</span>
            <span v-if="!scope.row.chargeBeginDate && !scope.row.chargeEndDate">-</span>
          </template>
        </el-table-column>
        <el-table-column label="计费标准" align="center" show-overflow-tooltip>
          <template slot-scope="scope">
            {{ scope.row.chargeCriterionDesc || '-' }}
          </template>
        </el-table-column>
        <el-table-column label="应收金额" align="center" width="120">
          <template slot-scope="scope">{{ keepTwoDecimal(scope.row.orderAmount) }}</template>
        </el-table-column>
        <el-table-column align="center" width="120">
          <template slot="header" slot-scope="scope">
            <el-popover placement="bottom" trigger="hover">
              <div slot="reference">
                <span>优惠金额</span>
                <img src="@/assets/image/report_tips_icon.png" alt="" style="vertical-align: text-bottom; width: 16px; height: 16px; margin-left: 8px" />
              </div>
              <div>一条费用包含多条账单时，优惠金额将根据应收金额占比均摊</div>
            </el-popover>
          </template>
          <template slot-scope="scope">{{ keepTwoDecimal(scope.row.preferentialAmount) }}</template>
        </el-table-column>
        <el-table-column label="违约金" align="center" width="120">
          <template slot-scope="scope">{{ keepTwoDecimal(scope.row.payPenaltyAmount) }}</template>
        </el-table-column>
        <el-table-column align="center" width="120">
          <template slot="header" slot-scope="scope">
            <el-popover placement="bottom" trigger="hover">
              <div slot="reference">
                <span>收款金额</span>
                <img src="@/assets/image/report_tips_icon.png" alt="" style="vertical-align: text-bottom; width: 16px; height: 16px; margin-left: 8px" />
              </div>
              <div>应收金额-优惠金额+违约金</div>
            </el-popover>
          </template>
          <template slot-scope="scope">{{ keepTwoDecimal(scope.row.payAmount) }}</template>
        </el-table-column>
        <el-table-column label="退款金额" align="center" width="120">
          <template slot-scope="scope">{{ keepTwoDecimal(scope.row.returnAmount) }}</template>
        </el-table-column>
      </el-table>
    </el-card>
  </el-drawer>
</template>

<script>
import { orderItemList } from '@/api/finance'
export default {
  data() {
    return {
      drawer: false,
      tableData: [],
      loading: false,
    }
  },
  watch: {
    drawer(val) {
      if (!val) this.init()
    },
  },
  methods: {
    async orderItemList(params = {}) {
      this.loading = true
      const { data } = await orderItemList(params)
      this.loading = false
      this.tableData = data || []
    },

    init() {
      this.tableData = []
      this.loading = false
    },
  },
}
</script>

<style lang="less" scoped>
.card {
  ::v-deep .el-card__body {
    padding: 24px !important;
  }
}
</style>
